import { createContext } from 'react';

import { WorkflowContextValue } from '../types/node-config';

export const WorkflowContext = createContext<WorkflowContextValue | null>(null);

WorkflowContext.displayName = 'WorkflowContext';
